export const GET_TYPES_SERVICE_REQUEST = "GET_TYPES_SERVICE_REQUEST";
export const GET_TYPES_SERVICE_SUCCESS = "GET_TYPES_SERVICE_SUCCESS";
export const GET_TYPES_SERVICE_FAILURE = "GET_TYPES_SERVICE_FAILURE";
